(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGORender"), require("FEGOEditor"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGORender", "FEGOEditor", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-fission-list/render"] = factory(require("VueDemi"), require("FEGORender"), require("FEGOEditor"), require("FEGOWebapi"));
	else
		root["/fego/component/common-fission-list/render"] = factory(root["VueDemi"], root["FEGORender"], root["FEGOEditor"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__4183__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 